import { MuiTelInput } from "mui-tel-input";

import { getFieldErrorMessage, useFieldContext, useShowFieldError } from "./form.context";

type Props = {
  label: string;
  disabled?: boolean;
};

export function PhoneField({ label, disabled }: Props) {
  const field = useFieldContext<string>();
  const errors = field.state.meta.errors;
  const hasError = useShowFieldError(errors);
  const errorMessage = getFieldErrorMessage(errors);

  return (
    <MuiTelInput
      name={field.name}
      value={field.state.value ?? ""}
      onChange={(v) => field.handleChange(v)}
      onBlur={field.handleBlur}
      label={label}
      error={hasError}
      defaultCountry="FR"
      disabled={disabled}
      variant="standard"
      fullWidth
      slotProps={{
        inputLabel: { shrink: true },
      }}
      helperText={hasError ? errorMessage : undefined}
    />
  );
}
